import React from 'react'

export default function Info() {
  return (
    <div className='text-center'>Mentorify Technologies Private Limited</div>
  )
}
